import { Store } from "_enums/enums";

export const ONBOARDING_TRIGGER_SIGNUP = "signup";
export const ONBOARDING_TRIGGER_LOGIN = "login";

/** Session-only hint for which consume source to send after navigation to dashboard. */
export const markOnboardingSignupVisit = () => {
  sessionStorage.setItem(Store.onboardingPendingTrigger, ONBOARDING_TRIGGER_SIGNUP);
};

export const markOnboardingLoginVisit = () => {
  sessionStorage.setItem(Store.onboardingPendingTrigger, ONBOARDING_TRIGGER_LOGIN);
};

export const peekOnboardingPendingTrigger = () =>
  sessionStorage.getItem(Store.onboardingPendingTrigger);

/** Clears the pending trigger — call only when consume will run on the dashboard. */
export const consumeOnboardingPendingTrigger = () => {
  const trigger = sessionStorage.getItem(Store.onboardingPendingTrigger);
  if (trigger) {
    sessionStorage.removeItem(Store.onboardingPendingTrigger);
  }
  return trigger;
};
